import { gsap } from 'gsap';

document.addEventListener('DOMContentLoaded', () => {
	const button = document.getElementById('offcanvas-toggler');
	const offcanvas = document.getElementById('offcanvas-main');

	gsap.set(offcanvas, { xPercent: 100 });

	button?.addEventListener('click', () => {
		const isOpen = offcanvas._gsap && offcanvas._gsap.xPercent === 0;

		isOpen ? button.classList.remove('active') : button.classList.add('active');

		button?.classList.toggle('inverted', !isOpen);
		gsap.to(offcanvas, {
			xPercent: isOpen ? 100 : 0,
			duration: 0.3,
			ease: "power2.out",
		});
	});
});
